import React, { FC } from 'react';
import type { Drawing as DrawingFields } from '@/generated/graphql';

type DrawingProps = {
    fields: DrawingFields;
};

const Drawing: FC<DrawingProps> = ({ fields }) => {
    return (
        <section>
            <p>
                {fields.id} Drawing {fields.adminTitle}
            </p>
        </section>
    );
};

export default Drawing;
